




























import Vue, { PropType } from "vue";
import { Pollutant, MuniFeatureProperties } from "@/types";
import { mapState } from "vuex";
import MuniDataDownload from "./MuniDataDownload.vue";

export default Vue.extend({
  props: {
    pollutant: { type: Object as PropType<Pollutant> },
    featProps: { type: Object as PropType<MuniFeatureProperties> }
  },
  components: { MuniDataDownload },
  computed: mapState(["lang"]),
  methods: {
    closePopup() {
      this.$emit("close-popup");
    },
    roundPollutantValue(n: number) {
      const rounded = parseFloat(n.toPrecision(2));
      if (rounded >= 1000) {
        return rounded.toLocaleString("fi-FI", { useGrouping: true });
      }
      return rounded;
    }
  }
});
